<template>
  <div>
    <div id="generalTemplate">
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='generalTemplate_banner'">
          <div v-if="item.content!==undefined&&item.content!==null&&item.content.length>0" class="generalTemplate_banner" id="generalTemplate_banner">
            <!-- <div class="generalTemplate_banner_list clearfix_"> -->
              <el-carousel :interval="3000" arrow="" style="width: 100%;height: 100%">
                <el-carousel-item v-for="(val,idx) in item.content" :key="idx" style="width: 100%;height: 100%;margin:0 auto;background:#fff;text-align: center;cursor: pointer;">
                  <img :data-idx="index" @click="goto(val)" :src="val.pic" style="height:540px;" alt="">
                </el-carousel-item>
              </el-carousel>
            <!-- </div> -->
          </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='generalTemplate_goods1'">
          <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="generalTemplate_goods1" id="generalTemplate_goods1">
            <div class="generalTemplate_goods1_txt clearfix_">
                <div class="fl generalTemplate_goods1_title">{{item.title}}</div>
                <div class="fl generalTemplate_goods1_describe">{{item.remark}}</div>
            </div>
            <div class="generalTemplate_goods1_box clearfix_">
                <div :style="{background:(backgroundImgLeft1==1?'url(http://img.source.9188cn.com/generalTemplate_goods1_left_red.png)':'url(http://img.source.9188cn.com/generalTemplate_goods1_left.png)')}" @mouseenter="onMouseOver(1,item.parentName,item.goods.length)" @mouseleave="onMouseout(1,item.parentName,item.goods.length)" @click="prev(item.parentName)" class="generalTemplate_goods1_left fl"></div>
                <div class="generalTemplate_goods1_list_box fl">
                    <div :style="{width:item.goods.length*400+'px',transform: 'translate3d('+prevNum1+'px, 0px, 0px)'}" class="generalTemplate_goods1_list clearfix_">
                        <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="fl generalTemplate_goods1_item fl">
                          <div class="generalTemplate_goods1_item_img"><img :src="val.pic?val.pic:noImg"></div>
                          <div class="generalTemplate_goods1_item_name">{{val.name}}</div>
                          <div class="generalTemplate_goods1_item_price">¥{{val.price}}</div>
                        </div>
                    </div>
                </div>
                <div :style="{background:(backgroundImgRight1==1?'url(http://img.source.9188cn.com/generalTemplate_goods1_right_red.png)':'url(http://img.source.9188cn.com/generalTemplate_goods1_right.png)')}" @mouseenter="onMouseOver(2,item.parentName,item.goods.length)" @mouseleave="onMouseout(2,item.parentName,item.goods.length)" @click="next(item.parentName,item.goods.length)" class="generalTemplate_goods1_right fl"></div>
            </div>
          </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='generalTemplate_goods1_copy1'">
          <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="generalTemplate_goods1" id="generalTemplate_goods1">
            <div class="generalTemplate_goods1_txt clearfix_">
                <div class="fl generalTemplate_goods1_title">{{item.title}}</div>
                <div class="fl generalTemplate_goods1_describe">{{item.remark}}</div>
            </div>
            <div class="generalTemplate_goods1_box clearfix_">
                <div :style="{background:(backgroundImgLeft2==1?'url(http://img.source.9188cn.com/generalTemplate_goods1_left_red.png)':'url(http://img.source.9188cn.com/generalTemplate_goods1_left.png)')}" @mouseenter="onMouseOver(1,item.parentName,item.goods.length)" @mouseleave="onMouseout(1,item.parentName,item.goods.length)" @click="prev(item.parentName)" class="generalTemplate_goods1_left fl"></div>
                <div class="generalTemplate_goods1_list_box fl">
                    <div :style="{width:item.goods.length*400+'px',transform: 'translate3d('+prevNum2+'px, 0px, 0px)'}" class="generalTemplate_goods1_list clearfix_">
                        <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="fl generalTemplate_goods1_item fl">
                          <div class="generalTemplate_goods1_item_img"><img :src="val.pic?val.pic:noImg"></div>
                          <div class="generalTemplate_goods1_item_name">{{val.name}}</div>
                          <div class="generalTemplate_goods1_item_price">¥{{val.price}}</div>
                        </div>
                    </div>
                </div>
                <div :style="{background:(backgroundImgRight2==1?'url(http://img.source.9188cn.com/generalTemplate_goods1_right_red.png)':'url(http://img.source.9188cn.com/generalTemplate_goods1_right.png)')}" @mouseenter="onMouseOver(2,item.parentName,item.goods.length)" @mouseleave="onMouseout(2,item.parentName,item.goods.length)" @click="next(item.parentName,item.goods.length)" class="generalTemplate_goods1_right fl"></div>
            </div>
          </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='generalTemplate_goods1_copy2'">
          <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="generalTemplate_goods1" id="generalTemplate_goods1">
            <div class="generalTemplate_goods1_txt clearfix_">
                <div class="fl generalTemplate_goods1_title">{{item.title}}</div>
                <div class="fl generalTemplate_goods1_describe">{{item.remark}}</div>
            </div>
            <div class="generalTemplate_goods1_box clearfix_">
                <div :style="{background:(backgroundImgLeft3==1?'url(http://img.source.9188cn.com/generalTemplate_goods1_left_red.png)':'url(http://img.source.9188cn.com/generalTemplate_goods1_left.png)')}" @mouseenter="onMouseOver(1,item.parentName,item.goods.length)" @mouseleave="onMouseout(1,item.parentName,item.goods.length)" @click="prev(item.parentName)" class="generalTemplate_goods1_left fl"></div>
                <div class="generalTemplate_goods1_list_box fl">
                    <div :style="{width:item.goods.length*400+'px',transform: 'translate3d('+prevNum3+'px, 0px, 0px)'}" class="generalTemplate_goods1_list clearfix_">
                        <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="fl generalTemplate_goods1_item fl">
                          <div class="generalTemplate_goods1_item_img"><img :src="val.pic?val.pic:noImg"></div>
                          <div class="generalTemplate_goods1_item_name">{{val.name}}</div>
                          <div class="generalTemplate_goods1_item_price">¥{{val.price}}</div>
                        </div>
                    </div>
                </div>
                <div :style="{background:(backgroundImgRight3==1?'url(http://img.source.9188cn.com/generalTemplate_goods1_right_red.png)':'url(http://img.source.9188cn.com/generalTemplate_goods1_right.png)')}" @mouseenter="onMouseOver(2,item.parentName,item.goods.length)" @mouseleave="onMouseout(2,item.parentName,item.goods.length)" @click="next(item.parentName,item.goods.length)" class="generalTemplate_goods1_right fl"></div>
            </div>
          </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='generalTemplate_recommend1'||item.parentName=='generalTemplate_recommend1_copy1'||item.parentName=='generalTemplate_recommend1_copy2'">
          <div v-if="item.content!==undefined&&item.content!==null&&item.content.length>0" class="generalTemplate_recommend1" id="generalTemplate_recommend1">
            <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx" class="generalTemplate_recommend1_img"><img :src="val.pic"></div>
          </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='generalTemplate_goods2'||item.parentName=='generalTemplate_goods2_copy1'||item.parentName=='generalTemplate_goods2_copy2'">
          <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="generalTemplate_goods2" id="generalTemplate_goods2">
            <div class="generalTemplate_goods1_txt clearfix_">
                <div class="fl generalTemplate_goods1_title">{{item.title}}</div>
                <div class="fl generalTemplate_goods1_describe">{{item.remark}}</div>
            </div>
            <div class="generalTemplate_goods2_list clearfix_">
                <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="generalTemplate_goods2_item fl">
                    <div class="generalTemplate_goods2_item_img"><img :src="val.pic?val.pic:noImg"></div>
                    <div class="generalTemplate_goods2_item_name">{{val.name}}</div>
                    <div class="generalTemplate_goods2_item_price">¥{{val.price}}</div>
                </div>
            </div>
          </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='generalTemplate_recommend2'||item.parentName=='generalTemplate_recommend2_copy1'||item.parentName=='generalTemplate_recommend2_copy2'">
          <div v-if="item.content!==undefined&&item.content!==null&&item.content.length>0" class="generalTemplate_recommend1" id="generalTemplate_recommend2">
            <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx" class="generalTemplate_recommend1_img"><img :src="val.pic"></div>
          </div>
        </div>
    </div>
  </div>
</template>
<style>
#generalTemplate{
    background: #f4f4f4;
    padding-bottom: 1px;
}
.generalTemplate_banner{
    width: 100%;
    height: 540px;
    margin-bottom: 70px;
    /* overflow: hidden; */
}
.generalTemplate_banner_list{
    width: 600%;
    position: absolute;
    top: 0;
    left: 0;
}
.generalTemplate_banner_img{
    width: 60%;
}
.generalTemplate_banner_img img{
    display: block;
    margin: 0 auto;
    height: 540px;
}
.generalTemplate_goods1{
    width: 1344px;
    margin: 0 auto;
    margin-bottom: 70px;
    position: relative;
}
.generalTemplate_goods1_txt{
    width: 1184px;
    margin: 0 auto;
    margin-bottom: 50px;
}
.generalTemplate_goods1_title{
    font-size: 32px;
    color: #333;
    margin-right: 20px;
    font-weight: 500;
}
.generalTemplate_goods1_describe{
    font-size: 20px;
    color: #666;
    margin-top: 12px;
}
.generalTemplate_goods1_left{
    width: 64px;
    height: 64px;
    background: url("http://img.source.9188cn.com/generalTemplate_goods1_left.png");
    background-size: 100%;
    margin-top: 220px;
    cursor: pointer;
}
/* .generalTemplate_goods1_left:hover{
    width: 64px;
    height: 64px;
    background: url("http://img.source.9188cn.com/generalTemplate_goods1_left_red.png");
    background-size: 100%;
} */
.generalTemplate_goods1_right{
    width: 64px;
    height: 64px;
    background: url("http://img.source.9188cn.com/generalTemplate_goods1_right.png");
    background-size: 100%;
    margin-top: 220px;
    cursor: pointer;
    margin-left: 16px;
}
/* .generalTemplate_goods1_right:hover{
    width: 64px;
    height: 64px;
    background: url("http://img.source.9188cn.com/generalTemplate_goods1_right_red.png");
    background-size: 100%;
    margin-left: 9px;
} */
.generalTemplate_goods1_list_box{
    position: relative;
    width: 1200px;
    height: 503px;
    overflow: hidden;
}
.generalTemplate_goods1_list{
    width: 100%;
    overflow: hidden;
    transition-duration:1s;
}
.generalTemplate_goods1_item{
    margin-left: 16px;
    background: #fff;
    width: 384px;
    border-radius: 15px;
    overflow: hidden;
    padding-bottom: 20px;
    transition: box-shadow .15s ease-in;
}
.generalTemplate_goods1_item:hover{
    box-shadow: 0 0 16px #ccc;
}
.generalTemplate_goods1_item_img{
    width: 384px;
    height: 384px;
    margin-bottom: 30px;
}
.generalTemplate_goods1_item_img img{
    width: 384px;
    height: 384px;
}
.generalTemplate_goods1_item_name{
    font-size: 24px;
    color: #333;
    padding: 0 25px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 25px;
}
.generalTemplate_goods1_item_price{
    font-size: 20px;
    color: #dd2c3a;
    padding: 0 25px;
}
.generalTemplate_recommend1{
    width: 1184px;
    height: 200px;
    position: relative;
    margin: 0 auto;
    margin-bottom: 70px;
}
/* .generalTemplate_recommend1:last-child{
    margin-bottom: 0;
} */
.generalTemplate_recommend1_img{
    width: 1184px;
    height: 200px;
}
.generalTemplate_recommend1_img img{
    width: 1184px;
    height: 200px;
}
.generalTemplate_goods2{
    width: 1184px;
    position: relative;
    margin: 0 auto;
    margin-bottom: 70px;
}
.generalTemplate_goods2_item{
    width: 284px;
    border-radius: 15px;
    background: #fff;
    margin-right: 16px;
    margin-bottom: 16px;
    overflow: hidden;
    padding-bottom: 30px;
}
.generalTemplate_goods2_item:nth-child(4n){
    margin-right: 0;
}
.generalTemplate_goods2_item_img{
    width: 284px;
    height: 284px;
    margin-bottom: 30px;
}
.generalTemplate_goods2_item_img img{
    width: 284px;
    height: 284px;
}
.generalTemplate_goods2_item_name{
    height: 60px;
    padding: 0 24px;
    color: #333;
    font-size: 22px;
    line-height: 30px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: 16px;
}
.generalTemplate_goods2_item_price{
    padding: 0 24px;
    font-size: 16px;
    color: #dd2c3a;
}
.el-carousel__container{
    height: 100%!important;
    overflow: hidden;
}
</style>
<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.js';
import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      allData:[],
      noImg:require("@/assets/img/aa.png"),
      prevN1:0,
      prevN2:0,
      prevN3:0,
      prevNum1:0,
      prevNum2:0,
			prevNum3:0,
			backgroundImgLeft1:0,
			backgroundImgLeft2:0,
			backgroundImgLeft3:0,
			backgroundImgRight1:0,
			backgroundImgRight2:0,
			backgroundImgRight3:0,
    }
  },
  mounted:function(){
    new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: true,
      autoplay:3000,
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
      },
      // 如果需要前进后退按钮
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
      }
    })
    this.getProject()
  },
  methods:{
    onMouseOver:function(btn,el,len){
			var t_=this
			if(btn==1){
				if(el=='generalTemplate_goods1'){
					if(t_.prevN1==0)return
					t_.backgroundImgLeft1=1
				}else if(el=='generalTemplate_goods1_copy1'){
					if(t_.prevN2==0)return
					t_.backgroundImgLeft2=1
				}else if(el=='generalTemplate_goods1_copy2'){
					if(t_.prevN3==0)return
					t_.backgroundImgLeft3=1
				}
			}else{
				var n=len-3
				if(el=='generalTemplate_goods1'){
					console.log( t_.prevN1==n , n<0 , t_.prevN1 , n )
					if(t_.prevN1==n||n<0)return
					t_.backgroundImgRight1=1
				}else if(el=='generalTemplate_goods1_copy1'){
					if(t_.prevN2==n||n<0)return
					t_.backgroundImgRight2=1
				}else if(el=='generalTemplate_goods1_copy2'){
					if(t_.prevN3==n||n<0)return
					t_.backgroundImgRight3=1
				}
			}
    	
		},
		onMouseout:function(btn,el,len){
			var t_=this
			if(btn==1){
				if(el=='generalTemplate_goods1'){
					t_.backgroundImgLeft1=0
				}else if(el=='generalTemplate_goods1_copy1'){
					t_.backgroundImgLeft2=0
				}else if(el=='generalTemplate_goods1_copy2'){
					t_.backgroundImgLeft3=0
				}
			}else{
				if(el=='generalTemplate_goods1'){
					t_.backgroundImgRight1=0
				}else if(el=='generalTemplate_goods1_copy1'){
					t_.backgroundImgRight2=0
				}else if(el=='generalTemplate_goods1_copy2'){
					t_.backgroundImgRight3=0
				}
			}
		},
    prev:function(el){
      var t_=this
      if(el=='generalTemplate_goods1'){
        if(t_.prevN1==0)return
        t_.prevNum1=(t_.prevN1*-400)+400
        t_.prevN1=--t_.prevN1
      }else if(el=='generalTemplate_goods1_copy1'){
        if(t_.prevN2==0)return
        t_.prevNum2=(t_.prevN2*-400)+400
        t_.prevN2=--t_.prevN2
      }else if(el=='generalTemplate_goods1_copy2'){
        if(t_.prevN3==0)return
        t_.prevNum3=(t_.prevN3*-400)+400
        t_.prevN3=--t_.prevN3
      }
    },
    next:function(el,len){
      var t_=this
      var n=len-3
      if(el=='generalTemplate_goods1'){
        if(t_.prevN1==n||n<0)return
        t_.prevNum1=(t_.prevN1*-400)-400
        t_.prevN1=++t_.prevN1
      }else if(el=='generalTemplate_goods1_copy1'){
        if(t_.prevN2==n||n<0)return
        t_.prevNum2=(t_.prevN2*-400)-400
        t_.prevN2=++t_.prevN2
      }else if(el=='generalTemplate_goods1_copy2'){
        if(t_.prevN3==n||n<0)return
        t_.prevNum3=(t_.prevN3*-400)-400
        t_.prevN3=++t_.prevN3
      }
    },
    gotoGoodsDetail:function(obj){
			var t_=this
			var href=t_.$router.resolve({name:'goodsdetails',query:{goodsId:obj.id,isSupplyChainGoods:2,supplyChainTenantId:obj.supplyChainTenantId}})
			window.open(href.href,'_blank')
    },
    goto:function(obj){
			var t_ = this
			if( obj.status==1 ){
                if(obj.atriceId=='')return
				var href=this.$router.resolve({
					name:'articleList',
					query:{
						id:obj.atriceId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==2){
				var d = obj.categoryId
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						id: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==3){
				var d = obj.search
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						txt: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==5){
				window.open(obj.link)
			}else if(obj.status==6){
				var href=t_.$router.resolve({
					name:'goodsdetails',
					query:{
						goodsId:obj.goodsId,
						isSupplyChainGoods:2,
						supplyChainTenantId:obj.supplyChainTenantId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==9){
				if(obj.module==1){
					var href=this.$router.resolve({name:'teamGoods'});
					window.open(href.href,'_blank')
				}else if(obj.module==3){
					var href=this.$router.resolve({name:'couponList'});
					window.open(href.href,'_blank')
				}else if(obj.module==5){
					var href=this.$router.resolve({name:'activityList'});
					window.open(href.href,'_blank')
				}else if(obj.module==6){
					var href=this.$router.resolve({name:'scoreChange'});
					window.open(href.href,'_blank')
				}
			}
    },
    getProject:function(){
      var t_=this
      let data = Qs.stringify({
        channel:2,
        id:this.$route.query.id,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/getProject`, data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
        t_.allData=res.data.results
        }else{
          return this.$router.push({path: '/'})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/generalTemplate1/generalTemplate1.vue